export interface IUser {
    tokenId?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    email?: string;
    username?: string;
    telephoneNumber?: string;
    docTypeCompany?: string;
    docNumberCompany?: string;
    checkDigit?: string;
    docTypeCustomer?: string;
    docNumberCustomer?: string;
    timeSession?: string;
  }

export interface IAfiliado {
    primerNombre: string;
    segundoNombre: string;
    primerApellido: string;
    segundoApellido: string;
    fechaNacimiento: string;
    tipoDocumento: string;
    numeroDocumento: string;
    genero: string;
    estadoCivil: string;
    telefono: string;
    celular: string;
    direccion: IDireccion;
    edad: string;
    afiliacion: IAfiliacion;
    salario: string;
    tipoSalario: string;
    tipoCargo: string;
    estado: string;
    pacs: IPac[];
    tarjetaMultiservicios: TarjetaMultiservicios;
    afiliarConyuge: boolean;
    afiliacionPac: AfiliacionPac;
}

export class AfiliacionPac {
    padre: TipoAfiliacion;
    madre: TipoAfiliacion;
    hermano: TipoAfiliacion;
    hijastro: TipoAfiliacion;
}

export class TipoAfiliacion {
  afiliar: boolean;
  afiliaciones: number;
}


export interface IDireccion {
    direccionPrincipal: string;
    departamento: IDepartamento;
    ciudad: ICiudad;
  }

export interface IDepartamento {
    id: string;
    nombre: string;
  }

export interface ICiudad {
    id: string;
    nombre: string;
  }

export interface IAfiliacion {
    fechaAfiliacion: string;
    fechaInicioVigencia:string;
    horasLaboradas: string;
    salario: string;
    tipoCargo: string;
    tipoSalario: string;
    categoria: string;
  }

export interface IPac {
    nivelEducativo: string;
    relacion: IRelacion;
    segundoNombre: string;
    estado: string;
    primerNombre: string;
    fechaNacimiento: string;
    fechaInicioVigencia: string;
    segundoApellido: string;
    cuotaMonetaria: ICuotaMonetaria;
    edad: string;
    bp: string;
    tipoDocumento: string;
    apellido: string;
    genero: string;
    discapacidad: string;
    numeroDocumento: string;
    tarjeta: ITarjeta;
  }

export interface IRelacion {
    descripcion: string;
    codigo: string;
  }

export interface ICuotaMonetaria {
    motivoBloqueo: string;
    salario: string;
  }

export interface ITarjeta {
    estado: string;
    numero: string;
    lote: string;
  }

export interface IValidataUser {
    idTypePerson: string;
    idPerson: string;
    idTypeEmployer: string;
    idEmployer: string;
}

export interface TarjetaMultiservicios {
  metodoPago: MetodoPago;
  fechaExpedicion: string;
  estado: string;
  causaCambio: string;
  ultimoMesPagado: string;
  motivoBloqueo: string;
  lote: string;
  fechaEntrega: string;
  gp: string;
  serialProximidad: string;
  numeroTarjeta: string;
  estadoEntrega: string;
}

export interface MetodoPago {
  id: string;
  nombre: string;
}
